<template>
  <aside class="aside">
    <router-link :to="{ name: 'AdminHome'}">Home</router-link>
    <router-link :to="{ name: 'AdminApis'}">APIS</router-link>
    <router-link :to="{ name: 'AdminSites'}">Sites</router-link>
<!--    <router-link :to="{ name: 'AdminTools'}">Tools</router-link>-->
<!--    <router-link :to="{ name: 'AdminCron'}">Cron</router-link>-->
  </aside>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: 'AdminMenu',
    computed: {
      ...mapGetters(['user']),
    }
  }
</script>